import React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import PrimaryTheme from '../Themes/Primary';
import DialogActions from '@material-ui/core/DialogActions';
import Input from './Input';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useHistory } from 'react-router-dom';
import { Reducers } from '../Interfaces/Interfaces';
import { forgotPassword } from '../redux/actions/userActions';

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const history = useHistory();

  const alert = useSelector((state: Reducers) => state.alert);

  const [emailValid, setEmailValid]: any = React.useState(null);
  const [email, setEmail]: any = React.useState('');
  const [submitted, setSubmitted]: any = React.useState(null);

  const handleSubmit = () => {
    // e.preventDefault();
    setSubmitted(true);

    let user = {
      username: email,

    // dispatch(forgotPassword(user));

      resetPasswordUrl: window.location.protocol + '//'+'dashboard.bankly.ng/account/reset'
    };

    dispatch(forgotPassword(user));


  };

  const validateEmail = (text: string) => {
    // email pattern
    let reg = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    if (!reg.test(text)) {
      setEmailValid(false);
      setEmail(text.toLowerCase());
    } else {
      setEmailValid(true);
      setEmail(text);
    }
  };

  React.useEffect(() => {
    if (Object.entries(alert).length !== 0) {
      if (!alert.successful) {
        // display error message
        // enqueueSnackbar(alert.message, { variant: "error" });

        dispatch({
          type: 'ALERT',
          payload: {}
        });
        dispatch({
          type: 'LOADING',
          payload: false
        });

        setSubmitted(false);


      } else {
        // enqueueSnackbar(alert.message, { variant: "success" });
        setSubmitted(false);

        setEmail("");

        dispatch({
          type: 'ALERT_MODAL',
          payload: true
        })

        dispatch({
          type: 'MODAL',
          payload: false
        })


        dispatch({
          type: 'ALERT',
          payload: {}
        });

        dispatch({
          type: 'LOADING',
          payload: false
        });
      }
    }
  }, [dispatch, enqueueSnackbar, alert, history]);

  return (
    <div className="col-md-12 modal-container">
      <DialogTitle>
        <div className="col-md-7 ml-auto mr-auto mb-3" style={{
          borderRadius: 50,
          backgroundColor: PrimaryTheme.warn,
          paddingTop: 15,
          paddingBottom: 15,
          textAlign: 'center',
        }}>
          <h6 className="mb-0" style={{
            color: PrimaryTheme.dark,
            fontFamily: PrimaryTheme.fonts?.RubikMedium
          }}>Forgot Password</h6>
        </div>
      </DialogTitle>
      <DialogContent>

        <div className="form-group mb-3">
          <label htmlFor="email"
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikMedium,
              fontSize: PrimaryTheme.fontSizes?.body
            }}>Registered Email</label>

          <Input type="email" isInput id="email"
            onChange={e => validateEmail(e.target.value)}
            value={email}
            disabled={submitted}
            showIcon
            required
            inputMode="email"
            valid={emailValid}
            errorText="Invalid email address"
            placeholder='Enter registered email' style={{
              fontFamily: PrimaryTheme.fonts?.RubikLight,
              backgroundColor: PrimaryTheme.background,
              color: PrimaryTheme.dark,//'#c0c7cd',
              padding: '1.1rem',
              borderRadius: 100
            }} />
        </div>

      </DialogContent>

      <DialogActions>
        <div className="form-group col-md-8 ml-auto mr-auto mb-0">

          <Input type="button" isInput id="submit"
            disabled={!emailValid || submitted}
            onClick={handleSubmit}
            value={submitted ? "Please wait..." : "Remind Me"}
            style={{
              fontFamily: PrimaryTheme.fonts?.RubikBold,
              backgroundColor: PrimaryTheme.primary,
              color: PrimaryTheme.white,
              padding: '1.1rem',
              borderRadius: 100
            }} />
        </div>
      </DialogActions>

    </div>

  )
}
